export const ADD_CARD = 'ADD_CARD';
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS';
export const ADD_CARD_FAILURE = 'ADD_CARD_FAILURE';

export const FETCH_CARDS_LIST = 'FETCH_CARDS_LIST';
export const FETCH_CARDS_LIST_SUCCESS = 'FETCH_CARDS_LIST_SUCCESS';
export const FETCH_CARDS_LIST_FAILURE = 'FETCH_CARDS_LIST_FAILURE';
export const CLEAR_CARDS_LIST = 'CLEAR_CARDS_LIST';
